import {Route} from "../../registry/routes.js"
import Favourites from "../../components/core/Favourites.vue";

const r = new Route("favourites", "favourites", {"favourites":Favourites}, {componentType:"main_component", title: "Favourites"}, [], true, null)

export default r